import { render, staticRenderFns } from "./sucai.vue?vue&type=template&id=32c443e8&scoped=true"
import script from "./sucai.vue?vue&type=script&lang=js"
export * from "./sucai.vue?vue&type=script&lang=js"
import style0 from "./sucai.vue?vue&type=style&index=0&id=32c443e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c443e8",
  null
  
)

export default component.exports